import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import auditedByDialog from '../dialog.auditedByDialog';
import editTestDialog from '../tests/dialog.editTestDialog';
import examinedByDialog from '../dialog.examinedByDialog';
import controller from './completed-assessment.controller';
import directive from './completed-assessment.directive';
import tests from '../tests';


export default angular.module('app.components.advisory.bcp.completedAssessment', [
  alerts,
  auditedByDialog,
  bcpDataService,
  confirmDialog,
  constants,
  editTestDialog,
  examinedByDialog,
  loaderService,
  tests,
  ssDialogService,
  userService,
])
  .directive('bcpCompletedAssessment', directive)
  .controller('CompletedAssessmentController', controller)
  .name;

console.log('app.components.advisory.bcp.completedAssessment created');
